import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SettingsHeader } from '../../Settings';
import './style.scss';
import { WALLPAPER_COLOR_CODES } from '../../../../../Helpers/Constants';
import {
    setWallpaperColor,
    resetWallpaperColor,
    setWallpaperPreviewColor,
} from '../../../../../Actions/WallpaperActions';

class Wallpaper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mouseOverState: false,
        };
    }

    setWallpaper = (color, ind) => {
        // Don't make API call if the same color is already selected
        if (this.props.wallpaperData.color === color) {
            return;
        }

        if (ind === 0) {
            this.props.resetWallpaperColor();
            return;
        }
        this.props.setWallpaperColor(color);
    };

    handleMouseOver = color => {
        this.props.setWallpaperPreviewColor(color);
    };

    handleMouseOut = () => {
        this.props.setWallpaperPreviewColor(this.props.wallpaperData.color);
    };

    render() {
        const { wallpaperData } = this.props;

        return (
            <Fragment>
                <div className="setting-container">
                    <div>
                        <div className="settinglist">
                            <SettingsHeader
                                handleBackFromSetting={this.props.backToChat}
                                label={'Set chat wallpaper'}
                            />

                            <div className="wallpaper-grid">
                                {WALLPAPER_COLOR_CODES.map((color, index) => (
                                    <div
                                        key={index}
                                        className={`wallpaper-item ${wallpaperData.color === color ? 'selected' : ''}`}
                                        style={{ backgroundColor: color }}
                                        onClick={() => {
                                            this.setWallpaper(color, index);
                                        }}
                                        onMouseOver={() => {
                                            this.handleMouseOver(color);
                                            this.setState({ mouseOverState: true });
                                        }}
                                        onMouseOut={() => {
                                            this.handleMouseOut();
                                            this.setState({ mouseOverState: false });
                                        }}
                                    >
                                        {index === 0 && <span className="wallpaper-label">Default</span>}
                                        {wallpaperData.color === color && <div className="selected-indicator">✓</div>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    wallpaperData: state.wallpaperData,
});

const mapDispatchToProps = {
    setWallpaperPreviewColor,
    setWallpaperColor,
    resetWallpaperColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(Wallpaper);

Wallpaper.propTypes = {
    backToChat: PropTypes.func,
    wallpaperData: PropTypes.object,
    setWallpaperPreviewColor: PropTypes.func,
    setWallpaperColor: PropTypes.func,
    resetWallpaperColor: PropTypes.func,
};
